import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import AutoComplete from '../AutoComplete';

var ChipInput = function (props) {
  return /*#__PURE__*/React.createElement(AutoComplete, _extends({
    allowCreate: true,
    multiple: true,
    showCreateText: false,
    createOnBlur: true,
    clearOnBlur: true
  }, props));
};

export default /*#__PURE__*/memo(ChipInput);